import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-view',
  templateUrl: './admin-view.component.html',
  styleUrls: ['../shared/styles/path-selection.css']
})
export class AdminViewComponent {

  constructor() { }
}
